import { createFileRoute } from "@tanstack/react-router"
import { OnlineBookingSettingsPage } from "@/pages/online-booking-settings"

// Keep routing thin; the page owns Organization resolution and the editor lifecycle.
export const Route = createFileRoute("/(settings)/settings/online-booking")({
	component: OnlineBookingSettingsPage,
})
